<template>
  <div class="section-container section-white">
    <div class="section-title">厂家与各类经销商多端共存</div>
    <div class="section-desc">模块化的设计架构，分别为经销商和厂商量身定做，但又能共同存在同一个平台上</div>
    
    <div class="relationship-diagram">
      <div class="left-entities">
        <div class="entity-item manufacturer">
          <div class="entity-content">
            <div class="entity-header">
              <div class="entity-icon">
                <img src="@/assets/img/icon1.png" alt="厂商" />
              </div>
              <div class="entity-title">厂商</div>
            </div>
            <div class="entity-desc">可在平台发布商品信息，并可授权销售指定的经销商</div>
          </div>
        </div>

        <div class="entity-item small-dealer">
          <div class="entity-content">
            <div class="entity-header">
              <div class="entity-icon">
                <img src="@/assets/img/icon4.png" alt="小型经销商" />
              </div>
              <div class="entity-title">小型经销商</div>
            </div>
            <div class="entity-desc">一般在平台只作为经销商的角色存在，直接为医院提供服务</div>
          </div>
        </div>
      </div>

      <div class="center-hub">
        <div class="hub-circle">
          <img src="@/assets/img/people.png" alt="合作关系" />
          <div class="pulse-circle"></div>
        </div>
      </div>

      <div class="right-entities">
        <div class="entity-item large-dealer">
          <div class="entity-content">
            <div class="entity-header">
              <div class="entity-icon">
                <img src="@/assets/img/icon3.png" alt="大型经销商" />
              </div>
              <div class="entity-title">大型经销商</div>
            </div>
            <div class="entity-desc">在平台中可作为供应商和经销商的角色存在，对厂商来说是经销商，对下游小型经销商来说是供应商</div>
          </div>
        </div>

        <div class="entity-item hospital">
          <div class="entity-content">
            <div class="entity-header">
              <div class="entity-icon">
                <img src="@/assets/img/icon5.png" alt="医院" />
              </div>
              <div class="entity-title">医院</div>
            </div>
            <div class="entity-desc">作为供应链的末端，平台中无实际操作，只有报消耗业务，由经销商的跟台人员操作</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreItemThree'
}
</script>

<style lang="scss" scoped>
.relationship-diagram {
  position: relative;
  width: 100%;
  max-width: 1200PX;
  margin: 0 auto;
  padding: 80PX 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20PX;
  min-height: 600PX;
}

.left-entities, .right-entities {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40PX;
  width: 380PX;
  height: 400PX;
}

.center-hub {
  flex-shrink: 0;
  align-self: center;
  
  .hub-circle {
    width: 420PX;
    height: 420PX;
    background: transparent;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-shadow: none;

    img {
      width: 98%;
      height: 98%;
      object-fit: contain;
    }

    .pulse-circle {
      position: absolute;
      top: -2%;
      left: -2%;
      width: 104%;
      height: 104%;
      border-radius: 50%;
      border: 2PX solid rgba(24, 144, 255, 0.2);
      animation: pulse 2s infinite;
      
      &::after {
        content: '';
        position: absolute;
        top: -2PX;
        left: -2PX;
        right: -2PX;
        bottom: -2PX;
        border-radius: 50%;
        border: 2PX solid rgba(54, 207, 201, 0.2);
        animation: pulse 2s infinite 1s;
      }
    }
  }
}

.entity-item {
  height: calc(50% - 40PX);
  display: flex;
  
  .entity-content {
    background: linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.95) 100%);
    border-radius: 14PX;
    padding: 20PX;
    box-shadow: 0 10PX 30PX rgba(24, 144, 255, 0.08);
    transition: all 0.3s ease;
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 1PX solid rgba(24, 144, 255, 0.1);
    backdrop-filter: blur(10PX);
    position: relative;
    min-height: 180PX;
    
    &:hover {
      transform: translateY(-5PX);
      box-shadow: 0 15PX 40PX rgba(24, 144, 255, 0.15);
      border-color: rgba(24, 144, 255, 0.2);
    }
  }

  .entity-header {
    display: flex;
    align-items: flex-start;
    gap: 16PX;
    margin-bottom: 16PX;
    position: relative;
    z-index: 2;
  }

  .entity-icon {
    position: absolute;
    top: 10%;
    transform: translateY(-50%);
    right: 15PX;
    width: 120PX;
    height: 120PX;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .entity-title {
    font-size: 20PX;
    font-weight: bold;
    color: #1890ff;
    text-shadow: 0 1PX 2PX rgba(24, 144, 255, 0.1);
  }

  .entity-desc {
    font-size: 14PX;
    color: #666;
    line-height: 1.7;
    flex-grow: 1;
    display: flex;
    align-items: flex-start;
    position: relative;
    z-index: 2;
    padding-right: 130PX;
    text-align: left;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.3;
  }
  100% {
    transform: scale(1);
    opacity: 0.6;
  }
}

@media screen and (max-width: 768PX) {
  .section-container {
    padding: 30PX 15PX;
  }

  .section-title {
    font-size: 22PX;
    margin-bottom: 12PX;
    text-align: center;
  }

  .section-desc {
    font-size: 14PX;
    margin-bottom: 30PX;
    text-align: center;
    padding: 0 20PX;
    line-height: 1.6;
  }

  .relationship-diagram {
    flex-direction: column;
    padding: 20PX 0;
    min-height: auto;
    gap: 30PX;
  }

  .left-entities, .right-entities {
    width: 100%;
    gap: 20PX;
    height: auto;
    padding: 0 15PX;
  }

  .entity-item {
    height: auto;
    margin-bottom: 0;
    position: relative;

    .entity-content {
      padding: 16PX 130PX 16PX 16PX;
      margin: 0;
      
      &:hover {
        transform: none;
      }
    }

    .entity-header {
      gap: 12PX;
      margin-bottom: 12PX;
    }

    .entity-icon {
      padding: 8PX;
      top: 60PX;
      right: -120PX;
      border-radius: 10PX;
    }

    .entity-title {
      font-size: 16PX;
    }

    .entity-desc {
      font-size: 13PX;
      line-height: 1.5;
      padding: 0;
    }
  }

  .center-hub {
    order: -1;
    margin: 0;
    width: 100%;
    
    .hub-circle {
      width: 280PX;
      height: 280PX;
      margin: 0 auto;

      img {
        width: 92%;
        height: 92%;
      }

      .pulse-circle {
        border-width: 1PX;
        
        &::after {
          border-width: 1PX;
        }
      }
    }
  }
}

@media screen and (max-width: 480PX) {
  .section-container {
    padding: 25PX 10PX;
  }

  .section-title {
    font-size: 20PX;
  }

  .section-desc {
    font-size: 13PX;
    padding: 0 15PX;
  }

  .relationship-diagram {
    padding: 15PX 0;
    gap: 20PX;
  }

  .left-entities, .right-entities {
    gap: 15PX;
    padding: 0 10PX;
  }

  .entity-item {


    .entity-title {
      font-size: 15PX;
    }

    .entity-desc {
      font-size: 12PX;
    }
  }

  .center-hub {
    .hub-circle {
      width: 240PX;
      height: 240PX;
    }
  }
}
</style>